"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeButtonWrapper = exports.RangeDot = exports.RangeTrack = exports.RangeContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.RangeContainer = styled_components_1.default.div `
  display: flex;
  
  > * + * {
    margin-left: 8px;
    margin-bottom: 16px;
  }
`;
exports.RangeTrack = styled_components_1.default.div `
  height: 8px;
  width: 100%;
  background-color: #f2f2f2;
  border-radius: 8px;
`;
exports.RangeDot = styled_components_1.default.div `
  height: 16px;
  width: 16px;
  background-color: var(--primary-color, #367bf5);
  border-radius: 50%;
`;
exports.RangeButtonWrapper = styled_components_1.default.div `
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
`;
//# sourceMappingURL=range.styled.js.map